import { Component } from '@opten/compiler/metadata/component';
import { debounce } from '@opten/reactive/debounce';
import { toggleClass } from '@opten/dom/toggle-class';
import { hasClass } from '@opten/dom/has-class';
import { addClass } from '@opten/dom/add-class';
import { removeClass } from '@opten/dom/remove-class';
import { getSelectorElementFromElement } from '@opten/dom/get-selector-element-from-element';

@Component({ className: 'js-navbar' })
export class NavbarComponent {
	private toggler: HTMLElement[];
	private scrollTo: HTMLElement[];
	private lastScrollTop = 0;
	private navbar: HTMLElement;
	private ignoreScrollDirection = false;

	constructor(private element: HTMLElement) {
		this.navbar = document.getElementsByClassName(
			'js-navbar-height'
		)[0] as HTMLElement;
		this.toggler = Array.from(
			element.getElementsByClassName('js-navbar-toggler')
		) as HTMLElement[];
		this.scrollTo = Array.from(
			element.getElementsByClassName('js-scroll-to')
		) as HTMLElement[];

		this.toggler.forEach((toggler) => {
			toggler.addEventListener('click', (e) => {
				e.preventDefault();
				toggleClass(document.body, 'is-open');
			});
		});

		document.addEventListener('click', (e) => {
			if (
				hasClass(document.body, 'is-open') &&
				!e.target.closest('header')
			) {
				e.preventDefault();
				toggleClass(document.body, 'is-open');
			}
		});

		window.addEventListener(
			'scroll',
			debounce(() => {
				const st =
					window.pageYOffset || document.documentElement.scrollTop;
				toggleClass(document.body, 'is-scrolled', st > 100);
				if (this.ignoreScrollDirection) {
					removeClass(document.body, 'is-scrolling-down');
				} else {
					if (st > this.lastScrollTop) {
						// downscroll code
						addClass(document.body, 'is-scrolling-down');
					} else {
						// upscroll code
						removeClass(document.body, 'is-scrolling-down');
					}
				}
				this.lastScrollTop = st <= 0 ? 0 : st;
			}, 0),
			false
		);

		this.handleSubNav();
		this.setNavSpace();

		window.addEventListener(
			'resize',
			debounce(() => {
				this.setNavSpace();
			}, 300)
		);
	}

	private handleSubNav() {
		if (this.scrollTo.length) {
			this.scrollTo.reverse();
			this.scrollTo.forEach((scrollTo) => {
				scrollTo.addEventListener('click', () => {
					this.ignoreScrollDirection = true;
					setTimeout(() => {
						this.ignoreScrollDirection = false;
					}, 2000);
				});
			});
			window.addEventListener(
				'scroll',
				debounce(() => {
					let foundActive = false;
					this.scrollTo.forEach((scrollTo, index) => {
						const target = getSelectorElementFromElement(scrollTo);
						if (target) {
							if (
								foundActive === false &&
								(target.getBoundingClientRect().top -
									this.navbar.clientHeight -
									50 <=
									0 ||
									document.documentElement.scrollHeight -
										(window.pageYOffset ||
											document.documentElement
												.scrollTop) -
										window.innerHeight <=
										3)
							) {
								addClass(scrollTo, 'is-active');
								foundActive = true;
							} else {
								removeClass(scrollTo, 'is-active');
							}
						}
					});
					if (foundActive === false) {
						addClass(
							this.scrollTo[this.scrollTo.length - 1],
							'is-active'
						);
						foundActive = true;
					}
				}, 100),
				false
			);
		}
	}

	private setNavSpace() {
		const item = document.querySelector(
			'#content>:first-child'
		) as HTMLElement;
		if (item) {
			item.style.paddingTop = `${this.navbar.clientHeight}px`;
		}
	}
}
